import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMScheduledPrompt } from "../graphql/mutations";
import { UpdateLLMScheduledPromptMutation } from "../API";

export async function updateLLMScheduledPromptStatus(
  id: string,
  status: string,
): Promise<GraphQLResult<UpdateLLMScheduledPromptMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMScheduledPrompt, {
      input: {
        id: id,
        status: status,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMScheduledPromptMutation>>;
}
